export default {
    '3CLDR': '3-Cylinder',
    '4CLDR': '4-Cylinder',
    '5CLDR': '5-Cylinder',
    '6CLDR': '6-Cylinder',
    '8CLDR': '8-Cylinder',
    '10CLDR': '10-Cylinder',
    '12CLDR': '12-Cylinder',
    '16CLDR': '16-Cylinder',
    RTR: 'Rotary Engine',
};
